import { render, staticRenderFns } from "./yeni2.vue?vue&type=template&id=00c1de24&scoped=true"
import script from "./yeni2.vue?vue&type=script&lang=js"
export * from "./yeni2.vue?vue&type=script&lang=js"
import style0 from "./yeni2.vue?vue&type=style&index=0&id=00c1de24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1de24",
  null
  
)

export default component.exports